// import api from './api';

// const authService = {
//   // Sign Up - Register new user
//   signup: async (userData) => {
//     try {
//       const response = await api.post('/auth/signup', {
//         username: userData.username,
//         email: userData.email,
//         password: userData.password,
//         role: userData.role || 'STUDENT',
//       });
//       return response.data;
//     } catch (error) {
//       throw error.response?.data || { message: error.message };
//     }
//   },

//   // Login - Get JWT token
//   login: async (username, password) => {
//     try {
//       const response = await api.post('/auth/login', {
//         username,
//         password,
//       });
      
//       // Save token and user info to localStorage
//       if (response.data.token) {
//         localStorage.setItem('token', response.data.token);
//         localStorage.setItem('user', JSON.stringify({
//           id: response.data.id,
//           username: response.data.username,
//           email: response.data.email,
//           role: response.data.role,
//         }));
//       }
      
//       return response.data;
//     } catch (error) {
//       throw error.response?.data || { message: error.message };
//     }
//   },

//   // Logout
//   logout: () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//     localStorage.removeItem('currentScreen');
//     localStorage.removeItem('registrationStep1Data');
//     localStorage.removeItem('registrationStep2Data');
//     localStorage.removeItem('completeRegistrationData');
//   },

//   // Get current user
//   getCurrentUser: () => {
//     const userStr = localStorage.getItem('user');
//     return userStr ? JSON.parse(userStr) : null;
//   },

//   // Check if user is logged in
//   isAuthenticated: () => {
//     return !!localStorage.getItem('token');
//   },
// };

// export default authService;
import api from './api';

const authService = {
  // Login - Get JWT token
  login: async (username, password) => {
    try {
      const response = await api.post('/auth/login', {
        username,
        password,
      });
      
      console.log('Auth response:', response.data);
      
      // Save token and user info to localStorage
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify({
          id: response.data.id,
          username: response.data.username,
          email: response.data.email,
          role: response.data.role,
          firstName: response.data.firstName || '',
          lastName: response.data.lastName  || '',
        }));

        // Clear guest session data when staff logs in
        const staffRole = response.data.role?.toUpperCase();
        if (staffRole && staffRole !== 'STUDENT' && staffRole !== 'PARENT') {
          localStorage.removeItem('guestMobile');
          localStorage.removeItem('guestScreen');
          sessionStorage.removeItem('guestMobile');
          localStorage.removeItem('registrationStep1Data');
          localStorage.removeItem('registrationStep2Data');
          localStorage.removeItem('registrationStep3Data');
          localStorage.removeItem('registrationPhotoPreview');
        }

        console.log('✅ Token saved to localStorage');
        console.log('✅ User saved to localStorage');
      }
      
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error.response?.data || { message: error.message };
    }
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('currentScreen');
    localStorage.removeItem('registrationStep1Data');
    localStorage.removeItem('registrationStep2Data');
    localStorage.removeItem('completeRegistrationData');
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is logged in
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
  forgotPassword: async (email) => {
    try {
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  resetPassword: async (token, newPassword) => {
    try {
      const response = await api.post('/auth/reset-password', { token, newPassword });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Reset password by mobile number (after OTP verified)
  resetPasswordByMobile: async (mobile, newPassword) => {
    try {
      const response = await api.post('/auth/reset-password-by-mobile', { mobile, newPassword });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

  // Verify that mobile is registered (for forgot password step 1)
  checkMobileExists: async (mobile) => {
    try {
      const response = await api.post('/auth/forgot-password', { mobile });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: error.message };
    }
  },

};

export default authService;